export {CustomerChoiceLabel} from './CustomerChoiceLabel';
